import axios from 'axios';
const Token = JSON.parse(localStorage.getItem("token"))

export const LeaveLists = async (page, pageSize) =>
    await axios.get(process.env.REACT_APP_API_URL + `/leaveRequest/?page=${page}&size=${pageSize}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })

export const CancelLeaveReqAPI = async (lId) =>
    await axios({
        method: 'patch',
        url: process.env.REACT_APP_API_URL + '/leaveRequest/cancel/',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        },
        data: { lId },
    })

export const SendLeaveReqAPI = async (lId) =>
    await axios({
        method: 'patch',
        url: process.env.REACT_APP_API_URL + '/leaveRequest/send/',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        },
        data: { lId },
    })

export const UploadDocument = async (formData) =>

    await axios({
        method: 'patch',
        url: process.env.REACT_APP_API_URL + '/leaveRequest/uploadDocument/',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${Token.access_token}`
        },
        data: formData,
    })

// export const DeleteLeaveReq = async (lId) =>
//     await axios.get(process.env.REACT_APP_API_URL + '/leaveRequest/' + lId, {
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-type": "Application/json",
//             "Authorization": `Bearer ${Token.access_token}`
//         }
//     })
